import { clearKoreChatData } from "../KoreChat/koreChatStorage";

/**
 * Module-scope listener that captures account data from SharedHeader auth events.
 * Installed at import time (before React mounts) to avoid race conditions where
 * the auth event fires before PersonalData's useEffect registers its listener.
 *
 * Also syncs localStorage.isLoggedIn so that getIsLoggedIn() returns the correct
 * value across all pages (tracking, BIFF, UI).
 */
let cachedAccountData: Record<string, unknown> | null = null;

if (typeof window !== "undefined") {
  const handleAuthSuccess = (e: Event) => {
    const detail = (e as CustomEvent).detail;
    if (!detail) return;
    cachedAccountData = detail;
    try {
      localStorage.setItem("isLoggedIn", "true");
    } catch {
      // localStorage may be unavailable (private browsing, quota exceeded)
    }
  };

  const handleLogout = () => {
    cachedAccountData = null;
    try {
      localStorage.removeItem("isLoggedIn");
    } catch {
      // localStorage may be unavailable
    }
    // The chat SDK's destroy() does not clear its tokens/storage, so the
    // ciaAuthToken cookie and chat state are removed here on logout.
    clearKoreChatData();
  };

  window.addEventListener("lmn:checkAuth:successful", handleAuthSuccess);
  window.addEventListener("lmn:login:successful", handleAuthSuccess);
  window.addEventListener("lmn:logout:successful", handleLogout);
}

export function getCachedAccountData() {
  return cachedAccountData;
}
